import { Navigate } from 'react-router-dom';

import { LoadingState } from '../../components/index.js';
import { useCurrentUser } from '../../lib/auth.js';

/**
 * The "Profile" nav item (APP_SPEC §33) resolves to the current user's own
 * public profile at `/users/:username` — there is exactly one profile
 * rendering path (`ProfilePage`), never a separate "my profile" view, so
 * a user always sees their profile exactly as anyone else would.
 */
export function OwnProfileRedirect() {
  const { data: user, isPending } = useCurrentUser();

  if (isPending) {
    return <LoadingState label="Loading your profile…" />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={`/users/${encodeURIComponent(user.username)}`} replace />;
}
